import { browser, isExtension } from '@web/constants/browserapi'

import { LOCALE_STORAGE_KEY, LocalePreference } from './constants'

// localStorage is read synchronously at startup so the first render is already in
// the right language. It is shared by the extension popup, tabs and the offscreen
// document (one origin). The service worker has no localStorage, so the extension
// mirrors the value into browser.storage.local, where background/i18n listens.

export const readLocalePreference = (): string | null => {
  try {
    return localStorage.getItem(LOCALE_STORAGE_KEY)
  } catch {
    return null
  }
}

export const writeLocalePreference = async (preference: LocalePreference) => {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, preference)
  } catch {
    // Storage blocked (private mode): the choice lasts for this session only.
  }
  if (isExtension) {
    await browser.storage.local.set({ [LOCALE_STORAGE_KEY]: preference })
  }
}

/** Another page (popup vs. full-page tab) changed the language. */
export const subscribeToLocalePreference = (callback: (preference: string | null) => void) => {
  if (typeof window === 'undefined') return () => {}
  const onStorage = (event: StorageEvent) => {
    if (event.key === LOCALE_STORAGE_KEY) callback(event.newValue)
  }
  window.addEventListener('storage', onStorage)
  return () => window.removeEventListener('storage', onStorage)
}
